export function getVideoProgressPercent({ s3: { parts = {} } = {} } = {}) {
  const allParts = Object.values(parts);
  return Math.floor((100 * allParts.filter((p) => p.ETag).length) / allParts.length) || 0;
}
